(function (angular) {
	'use strict';

	angular
		.module('fileUploadModule')
		.factory('FileUploadFactory', [
			'AJAX_UPLOAD_URL',
			'Upload',
			FileUploadFunction
		]);

	function FileUploadFunction(
		AJAX_UPLOAD_URL,
		Upload) {
		var factory = {
			createStateObj: createStateObj,
			resetUpload: resetUpload,
			uploadFiles: uploadFiles
		};

		return factory;

		function uploadFiles(stateObject, theFile, errFiles) {
			if(errFiles.length > 0) {
				stateObject.state = 'error';
				stateObject.required = true;
				stateObject.errorMessages = errFiles[0].$errorMessages;
			} else if (theFile) {
				delete stateObject.errorMessages;
				
				theFile.upload = Upload.upload({
					url: AJAX_UPLOAD_URL,
					withCredentials: true,
					data: {
						uploadFile: theFile,
						fileMapping: stateObject.fileMapping
					}
				});

				theFile.upload.then(function (response) {
					stateObject.state = 'done';
					stateObject.required = false;
					stateObject.fileName = theFile.name;
					stateObject.fileSize = theFile.size;
					stateObject.authUploadedFileUrl = response.data.authenticatedUrl;
					stateObject.uploadedFileUrl = response.data.uploadedFileUrl;
				}, function () {
					stateObject.state = 'error';
					stateObject.required = true;
					stateObject.uploadedFileUrl = '';
					stateObject.errorMessages = {
						upload: true
					};
				}, function (evt) {
					stateObject.state = 'in-progress';
					stateObject.progressPercent = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			}
		}

		function createStateObj(fileMapping) {
			var stateObj = {};
			resetUpload(stateObj);

			if(angular.isDefined(fileMapping)) {
				if(fileMapping === 'VERIFICATION_DOCUMENTS') {
					stateObj.validations = {
						pattern: '.pdf,.doc,.docx',
						maxSize: '20MB',
						restrictionMessage: 'PDF or Word Document only, Max size 20MB',
						patternMessage: 'The selected file is in the wrong format. Please choose a PDF file or Word document.'
					};
					stateObj.fileMapping = 'VERIFICATION_DOCUMENTS';

				} else if(fileMapping === 'IDENTIFICATION_DOCUMENT') {
					stateObj.validations = {
						pattern: '.pdf',
						maxSize: '20 MB',
						restrictionMessage: '(PDF only, max 20MB)',
						patternMessage: 'The selected file is in the wrong format. Please choose a PDF file.'
					};
					stateObj.fileMapping = 'IDENTIFICATION_DOCUMENT';
				}
			}

			return stateObj;
		}

		function resetUpload(stateObject) {
			stateObject.authUploadedFileUrl = '';
			stateObject.fileName = '';
			stateObject.fileSize = 0;
			stateObject.state = 'initial';
			stateObject.uploadedFileUrl = '';
			stateObject.progressPercent = 0;
			stateObject.required = true;
		}
	}
})(window.angular);